import React from "react";
import { Dropdown } from "react-bootstrap";
import { Card, Button, Row, Col } from "react-bootstrap";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faWallet,
  faChartBar,
  faChartLine,
  faDollarSign,
  faEye,
  faEyeSlash,
  faArrowTrendUp, // ✅ required
  faArrowTrendDown, // ✅ required
  faPlus,
  faPen,
  faArrowRight,
  faMoneyBillWave
} from "@fortawesome/free-solid-svg-icons";


const data = [
  { name: "Jan", value: 400 },
  { name: "Feb", value: 450 },
  { name: "Mar", value: 500 },
  { name: "Apr", value: 550 },
  { name: "May", value: 600 },
  { name: "Jun", value: 700 },
  { name: "Jul", value: 650 },
];

const BalanceCard3 = () => {
  return (
    <div
      className="container-fluid p-4"
      style={{
        background: "linear-gradient(90deg, #18181b 0%, #23272f85 100%)",
        border: "1px solid #23272f",
        color: "#fff",
        borderRadius: "12px",
        maxWidth: "500px",
        margin: "auto",
      }}
    >
     

    <Card className="shadow-lg" style={{ background: "linear-gradient(90deg, #18181b 0%, #23272f85 100%)", borderRadius: "15px", border: "none" }}>
      <Card.Body>
        {/* Header with wallet icon and title */}
        <Row className="d-flex align-items-center">
          <Col xs={2}>
            <div
              className="balance-icon d-flex align-items-center justify-content-center rounded-circle"
              style={{
                background: "linear-gradient(135deg, #2563eb 0%, #60a5fa 100%)",
                width: "50px",
                height: "50px",
                boxShadow: "0 2px 8px 0 rgba(37,99,235,0.12)",
              }}
            >
              <FontAwesomeIcon icon={faWallet} style={{ fontSize: "25px", color: "#fff" }} />
            </div>
          </Col>
          <Col xs={10}>
            <h4 className="text-white fw-bold mb-0">Crypto Balance</h4>
            <p className="text-muted mb-2">Your wallet overview</p>
          </Col>
        </Row>

        {/* Balance and Change Percentage */}
        <Row className="my-4">
          <Col xs={6}>
            <h3 className="text-white font-weight-bold">$15,800.25</h3>
            <p className="text-success">+7.2% since last month</p>
          </Col>
          <Col xs={6} className="text-end">
            <Button variant="dark" className="text-white py-2 px-4" style={{ borderRadius: "8px" }}>
              <FontAwesomeIcon icon={faArrowRight} className="me-2" />
              Withdraw
            </Button>
          </Col>
        </Row>

        {/* Portfolio Chart */}
        <Row>
          <Col>
            <ResponsiveContainer width="100%" height={200}>
              <LineChart data={data}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="value" stroke="#22c55e" strokeWidth={2} />
              </LineChart>
            </ResponsiveContainer>
          </Col>
        </Row>

        {/* Action Buttons */}
        <Row className="mt-4">
          <Col xs={6} className="mb-3">
            <Button variant="light" block style={{ borderRadius: "8px" }}>
              <FontAwesomeIcon icon={faMoneyBillWave} className="me-2" />
              Transfer Funds
            </Button>
          </Col>
          <Col xs={6}>
            <Button variant="light" block style={{ borderRadius: "8px" }}>
              <FontAwesomeIcon icon={faChartLine} className="me-2" />
              View Portfolio
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
 

    </div>
  );
};

export default BalanceCard3;
